import React from 'react';

const ChangeVideo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2ZM13.4697 6.46967C13.7626 6.17678 14.2374 6.17678 14.5303 6.46967L16.5303 8.46967C16.7448 8.68417 16.809 9.00676 16.6929 9.28701C16.5768 9.56727 16.3033 9.75 16 9.75H10C9.30964 9.75 8.75 10.3096 8.75 11V12C8.75 12.4142 8.41421 12.75 8 12.75C7.58579 12.75 7.25 12.4142 7.25 12V11C7.25 9.48122 8.48122 8.25 10 8.25H14.1893L13.4697 7.53033C13.1768 7.23744 13.1768 6.76256 13.4697 6.46967ZM7.46967 15.5303L9.46967 17.5303C9.76256 17.8232 10.2374 17.8232 10.5303 17.5303C10.8232 17.2374 10.8232 16.7626 10.5303 16.4697L9.81066 15.75H14C15.5188 15.75 16.75 14.5188 16.75 13V12C16.75 11.5858 16.4142 11.25 16 11.25C15.5858 11.25 15.25 11.5858 15.25 12V13C15.25 13.6904 14.6904 14.25 14 14.25H8C7.69665 14.25 7.42318 14.4327 7.30709 14.713C7.191 14.9932 7.25517 15.3158 7.46967 15.5303Z"
        fill="white"
      />
    </svg>
  );
};

export default ChangeVideo;
